import { render, staticRenderFns } from "./Literatures.vue?vue&type=template&id=34b7f189&scoped=true&"
import script from "./Literatures.vue?vue&type=script&lang=js&"
export * from "./Literatures.vue?vue&type=script&lang=js&"
import style0 from "./Literatures.vue?vue&type=style&index=0&id=34b7f189&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b7f189",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VImg,VSheet,VSkeletonLoader})
